import { Card, Colors, Text } from '@amelio/ui-library';

import { HIGHLIGHT_VALUE } from '../reportStyles';

import type { ReactNode } from 'react';

interface HighlightCardProps {
    icon: ReactNode;
    value: ReactNode;
    label: string;
    description?: string;
    dataTestId?: string;
}

/** One of the three summary cards (`MatrixHighlights`): an icon in a `bg-primary/10` disc, a big
 * value, a label and an optional description — matching the prototype's `KPICard.tsx`. */
export const HighlightCard = ({
    icon,
    value,
    label,
    description,
    dataTestId,
}: HighlightCardProps) => (
    <Card
        glass={'sm'}
        borderRadius={'2xl'}
        dataTestId={dataTestId}
    >
        <div className={'flex items-center gap-4'}>
            <div
                className={
                    'bg-primary/10 flex h-12 w-12 shrink-0 items-center justify-center rounded-lg'
                }
            >
                {icon}
            </div>

            <div className={'flex min-w-0 flex-col gap-0.5'}>
                <div className={`${HIGHLIGHT_VALUE} truncate`}>{value}</div>

                <Text
                    size={'small'}
                    weight={'medium'}
                    color={Colors.BASE_500}
                    truncate
                >
                    {label}
                </Text>

                {description && (
                    <Text
                        size={'small'}
                        color={Colors.BASE_400}
                        truncate
                    >
                        {description}
                    </Text>
                )}
            </div>
        </div>
    </Card>
);
